import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3e15b521&scoped=true"
import script from "@/components/common/BookDemo/index.js?vue&type=script&lang=js&external"
export * from "@/components/common/BookDemo/index.js?vue&type=script&lang=js&external"
import style0 from "./Index.vue?vue&type=style&index=0&id=3e15b521&prod&lang=scss&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=3e15b521&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e15b521",
  null
  
)

export default component.exports